export default __webpack_public_path__ + "static/media/cp_geo_bn.f964b073.svg";